import React from 'react'
import styled from 'styled-components'

const StyledDivider = styled.span`
  width: 1px;
  height: 12px;
  background: ${({ theme }) => theme.colors.border.default};
  display: inline-block;
  flex-shrink: 0;

  @media (max-width: 768px) {
    display: none;
  }
`

export const MetaDivider: React.FC = () => {
  return <StyledDivider />
}
